var _ = require('underscore');
var FeatureConfigModel = require('./../feature-config/FeatureConfigModel');
var billingConfigService = require('./../urls').billingConfigService;

var PAYMENT_PROCESSOR_NAMES = {
  GIP_PROCESSOR: 'GIP_PROCESSOR',
  MOCK_PROCESSOR: 'MOCK_PROCESSOR',
  TEMPUS_PROCESSOR: 'TEMPUS_PROCESSOR'
};

var PAYMENT_PROCESSOR_NAMES_ARRAY = _.keys(PAYMENT_PROCESSOR_NAMES);

var INVOICE_PROCESSOR_NAMES = {};

var INVOICE_PROCESSOR_NAMES_ARRAY = _.keys(INVOICE_PROCESSOR_NAMES);

/**
 * Model for billing configuration information. Uses the BillingConfigService and corresponds to the Billing Config
 *
 * @class BillingConfigModel
 * @extends FeatureConfigModel
 * @constructor
 */
var BillingConfigModel = FeatureConfigModel.extend({
  urlRoot: billingConfigService,
  PAYMENT_PROCESSOR_NAMES: PAYMENT_PROCESSOR_NAMES,
  PAYMENT_PROCESSOR_NAMES_ARRAY: PAYMENT_PROCESSOR_NAMES_ARRAY,

  INVOICE_PROCESSOR_NAMES: INVOICE_PROCESSOR_NAMES,
  INVOICE_PROCESSOR_NAMES_ARRAY: INVOICE_PROCESSOR_NAMES_ARRAY,

  /**
   * Get the config object for the currently selected processor
   * @method getCurrentProcessorConfig
   * @return {Object} the config object for the currently selected processor
   */
  getCurrentProcessorConfig: function () {
    var currentProcessorConfig = this.get('mockProcessorConfig');
    if (this.isTempusProcessor()) {
      currentProcessorConfig = this.get('tempusConfig');
    } else if (this.isGipProcessor()) {
      currentProcessorConfig = this.get('gipConfig');
    }
    return currentProcessorConfig;
  },

  /**
   * @method getPaymentProcessorName
   * @return {String} the name of the configured payment processor.
   */
  getPaymentProcessorName: function() {
    return this.get('paymentProcessorName');
  },

  /**
   * @method isMockProcessor
   * @return {boolean} true if the mock processor should be used.  False otherwise.
   */
  isMockProcessor: function() {
    return !this.isGipProcessor() && !this.isTempusProcessor();
  },

  /**
   * @method isGipProcessor
   * @return {boolean} true if the GIP processor should be used.  False otherwise.
   */
  isGipProcessor: function() {
    return this.getPaymentProcessorName() === PAYMENT_PROCESSOR_NAMES.GIP_PROCESSOR;
  },

  /**
   * @method isTempusProcessor
   * @return {boolean} true if the Tempus processor should be used.  False otherwise.
   */
  isTempusProcessor: function() {
    return this.getPaymentProcessorName() === PAYMENT_PROCESSOR_NAMES.TEMPUS_PROCESSOR;
  }
});

module.exports = new BillingConfigModel();

